// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadContent{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
}
.compactLoadItems{
    position: relative;
    width: 40%;
    height: 40%;
    background-color: transparent;
    display: block;
    justify-content: center;
    align-items: center;
}
.loadCont{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
}
.txtAdding{
    position: relative;
    font-size: small;
    color: #969696;
    width: 100%;
    text-align: center;
   
}
.LoadContent{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
}
.compactLoadItems{
    position: relative;
    width: 40%;
    height: 40%;
    background-color: transparent;
    display: block;
    justify-content: center;
    align-items: center;
}
.loadCont{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
}
.txtadding{
    position: relative;
    font-size: larger;
    color: #969696;
    width: 100%;
    text-align: center;
   
}
@keyframes adding{
    0%{
        transform: scale(0);
        opacity: 1;
    }
    100%{
        transform: scale(1);
        opacity: 0;
    }
}
.adding::after,.adding::before{
    animation: adding 2s linear infinite;
    content: '';
    border: 4px solid #969696;
    width: 48px;
    height: 48px;
    position: absolute;
    border-radius: 50%;
}
.adding::after{
    opacity: 0;
    animation-delay: 1s;
}
.adding{
    position: relative;
    left: -25%;
top: -50%;
}

.blink_me {
    display: inline-block;
    vertical-align: bottom;
    animation: blinker 1s linear infinite;
    animation-delay: -0.5s;
  }
  
  .blink_me span {
    float: left;
    overflow: hidden;
    animation: hideShow 5s linear infinite;
  }
  
  .blink_me span:nth-child(1) { animation-delay: -2s; }
  .blink_me span:nth-child(2) { animation-delay: -1s; }
  .blink_me span:nth-child(3) { animation-delay: -0s; }
  
  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
  @keyframes hideShow {
    0%, 16.6%, 33.33%, 100% { width: 0; }
    16.66%, 33.3% { width: auto; }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/styles/LoadAdding.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,kBAAkB;;AAEtB;AACA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;AACA;IACI,oCAAoC;IACpC,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd,SAAS;AACT;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,qCAAqC;IACrC,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA,8BAA8B,oBAAoB,EAAE;EACpD,8BAA8B,oBAAoB,EAAE;EACpD,8BAA8B,oBAAoB,EAAE;;EAEpD;IACE;MACE,UAAU;IACZ;EACF;EACA;IACE,0BAA0B,QAAQ,EAAE;IACpC,gBAAgB,WAAW,EAAE;EAC/B","sourcesContent":[".LoadContent{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: transparent;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.compactLoadItems{\r\n    position: relative;\r\n    width: 40%;\r\n    height: 40%;\r\n    background-color: transparent;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.loadCont{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 50%;\r\n}\r\n.txtAdding{\r\n    position: relative;\r\n    font-size: small;\r\n    color: #969696;\r\n    width: 100%;\r\n    text-align: center;\r\n   \r\n}\r\n.LoadContent{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: transparent;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.compactLoadItems{\r\n    position: relative;\r\n    width: 40%;\r\n    height: 40%;\r\n    background-color: transparent;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.loadCont{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 50%;\r\n}\r\n.txtadding{\r\n    position: relative;\r\n    font-size: larger;\r\n    color: #969696;\r\n    width: 100%;\r\n    text-align: center;\r\n   \r\n}\r\n@keyframes adding{\r\n    0%{\r\n        transform: scale(0);\r\n        opacity: 1;\r\n    }\r\n    100%{\r\n        transform: scale(1);\r\n        opacity: 0;\r\n    }\r\n}\r\n.adding::after,.adding::before{\r\n    animation: adding 2s linear infinite;\r\n    content: '';\r\n    border: 4px solid #969696;\r\n    width: 48px;\r\n    height: 48px;\r\n    position: absolute;\r\n    border-radius: 50%;\r\n}\r\n.adding::after{\r\n    opacity: 0;\r\n    animation-delay: 1s;\r\n}\r\n.adding{\r\n    position: relative;\r\n    left: -25%;\r\ntop: -50%;\r\n}\r\n\r\n.blink_me {\r\n    display: inline-block;\r\n    vertical-align: bottom;\r\n    animation: blinker 1s linear infinite;\r\n    animation-delay: -0.5s;\r\n  }\r\n  \r\n  .blink_me span {\r\n    float: left;\r\n    overflow: hidden;\r\n    animation: hideShow 5s linear infinite;\r\n  }\r\n  \r\n  .blink_me span:nth-child(1) { animation-delay: -2s; }\r\n  .blink_me span:nth-child(2) { animation-delay: -1s; }\r\n  .blink_me span:nth-child(3) { animation-delay: -0s; }\r\n  \r\n  @keyframes blinker {\r\n    50% {\r\n      opacity: 0;\r\n    }\r\n  }\r\n  @keyframes hideShow {\r\n    0%, 16.6%, 33.33%, 100% { width: 0; }\r\n    16.66%, 33.3% { width: auto; }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
